import styled from "styled-components";
import {
  SubTitlesProps,
  ToggleBtnProps,
} from "../../interfaces/ToggleMobMenuInterface";

export const TogglePersonalContainer = styled.div`
  min-height: 3.375rem;

  .block__with__subtitles {
    position: relative;
    display: flex;
    justify-content: space-between;
    border-bottom: 4px solid #ffffffd1;
  }

  .block__title {
    display: flex;
    border-bottom: 4px solid #ffffffd1;
  }

  .link__styles {
    display: block;
    /* width: 100%; */
    padding-left: 0.625rem;
    padding-right: 0.625rem;
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
    font-weight: bold;
    font-size: 1.25rem;
    color: white;
  }
`;

export const ToggleExpandButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== "expanded",
})<ToggleBtnProps>`
  position: absolute;
  user-select: none;
  background: transparent;
  border: none;
  right: 1.25rem;
  top: 22%;
  font-weight: bold;
  transform: rotate(${({ expanded }) => (expanded ? "180deg" : "0deg")});
  transition: transform 400ms ease-in-out;
`;

export const CollapsibleContainer = styled.ul.withConfig({
  shouldForwardProp: (prop) => prop !== "isOpen",
})<SubTitlesProps>`
  overflow: hidden;
  transition: all 0.7s ease-in-out;
  max-height: ${({ isOpen }) => (isOpen ? "24rem" : "0")};

  li {
    padding-left: 1rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    font-size: 1.125rem;
    font-weight: 600;
    color: white;
  }
`;
